import { render, staticRenderFns } from "./FbaOrderDetail.vue?vue&type=template&id=43459c48&scoped=true"
import script from "./FbaOrderDetail.vue?vue&type=script&lang=js"
export * from "./FbaOrderDetail.vue?vue&type=script&lang=js"
import style0 from "./FbaOrderDetail.vue?vue&type=style&index=0&id=43459c48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43459c48",
  null
  
)

export default component.exports